import React, { useReducer, useEffect } from "react";
import { Switch, Route, Redirect } from "react-router";
import { Navbar, Asidebar } from "../Components/Components";

import { Dashboard } from "../views/Dashboard/Dashboard";
import { Ventas } from "../views/Ventas/Ventas";
import { Operaciones } from "../views/Operaciones/Operaciones";
import { Clientes } from "../views/Clientes/Clientes";
import { Segmentacion } from "../views/Segmentacion/Segmentacion";
import { Bonos } from "../views/Bonos/Bonos";
import { Oficinas } from "../views/Oficinas/Oficinas";
import { Agentes } from "../views/Agentes/Agentes";
import { Configuracion } from "../views/Configuracion/Configuracion";
import { Grupos } from "../views/Grupos/Grupos";
import { Reportes } from "../views/Reportes/Reportes";
import { Login } from "../views/Login/Login";
import { ViewOficina } from "../views/Oficinas/ViewOficina";
import { AuthContext } from "../auth/AuthContext";
import { authReducer } from "../auth/authReducer";
import { ViewAgente } from "../views/Agentes/ViewAgente";
import { ViewGrupo } from "../views/Grupos/ViewGrupo";
import { ViewPromotoria } from "../views/Grupos/ViewPromotorias";
import { Administracion } from "../views/Administracion/Administracion";

const init = () => {
  const dataStorage = JSON.parse(localStorage.getItem("userAryaCorp"));

  if (!dataStorage) return { logged: false };

  const today = new Date();
  const year = today.getFullYear();
  const month = ("0" + (today.getMonth() + 1)).slice(-2);
  const day = ("0" + today.getDate()).slice(-2);

  if (dataStorage.date_login !== `${year}-${month}-${day}`)
    return { logged: false };

  return JSON.parse(localStorage.getItem("userAryaCorp"));
};

export const DashboardRoutes = ({ state, updateState, loadData }) => {
  const [usuario, dispatch] = useReducer(authReducer, {}, init);

  useEffect(() => {
    localStorage.setItem("userAryaCorp", JSON.stringify(usuario));
  }, [usuario]);

  return (
    <React.Fragment>
      <AuthContext.Provider value={{ usuario, dispatch }}>
        <React.Fragment>
          <Switch>
            
            <Route exact path="/login">
              <Login
                initState={state}
                updateState={updateState}
                loadData={loadData}
              />
            </Route>

            {usuario.logged ? (
              <>
                <Navbar state={state} updateState={updateState} />
                <Asidebar state={state} updateState={updateState} />

                <Route exact path="/dashboard">
                  <Dashboard
                    state={state}
                    updateState={updateState}
                    loadData={loadData}
                  />
                </Route>
                <Route exact path="/">
                  <Ventas
                    state={state}
                    updateState={updateState}
                    loadData={loadData}
                  />
                </Route>
                <Route exact path="/operaciones">
                  <Operaciones
                    state={state}
                    updateState={updateState}
                    loadData={loadData}
                  />
                </Route>
                <Route exact path="/clientes">
                  <Clientes
                    state={state}
                    updateState={updateState}
                    loadData={loadData}
                  />
                </Route>
                <Route exact path="/segmentacion">
                  <Segmentacion
                    state={state}
                    updateState={updateState}
                    loadData={loadData}
                  />
                </Route>
                <Route exact path="/bonos">
                  <Bonos
                    initState={state}
                    updateState={updateState}
                    loadData={loadData}
                  />
                </Route>
                <Route exact path="/oficinas">
                  <Oficinas
                    state={state}
                    updateState={updateState}
                    loadData={loadData}
                  />
                </Route>
                <Route exact path="/oficinas/:id">
                  <ViewOficina
                    initState={state}
                    updateState={updateState}
                    loadData={loadData}
                  />
                </Route>
                <Route exact path="/agentes">
                  <Agentes
                    initState={state}
                    updateState={updateState}
                    loadData={loadData}
                  />
                </Route>
                <Route exact path="/agentes/:id">
                  <ViewAgente
                    initState={state}
                    updateState={updateState}
                    loadData={loadData}
                  />
                </Route>
                <Route exact path="/grupos">
                  <Grupos
                    state={state}
                    updateState={updateState}
                    loadData={loadData}
                  />
                </Route>
                <Route exact path="/grupos/:id">
                  <ViewGrupo
                    initState={state}
                    updateState={updateState}
                    loadData={loadData}
                  />
                </Route>
                <Route exact path="/promotorias/:id">
                  <ViewPromotoria
                    initState={state}
                    updateState={updateState}
                    loadData={loadData}
                  />
                </Route>
                <Route exact path="/reportes">
                  <Reportes
                    state={state}
                    updateState={updateState}
                    loadData={loadData}
                  />
                </Route>
                <Route exact path="/configuracion">
                  <Configuracion
                    initState={state}
                    updateState={updateState}
                    loadData={loadData}
                  />
                </Route>
                <Route exact path="/administracion">
                  <Administracion 
                  initState={state}
                  updateState={updateState}
                  />
                </Route>
              </>
            ) : (
              <Redirect to="/login" />
            )}
          </Switch>
        </React.Fragment>
      </AuthContext.Provider>
    </React.Fragment>
  );
};
